import { useDispatch, useSelector } from 'react-redux';
import { getRolesAction } from '@store/staticData';
import { getRolesSD } from '../selectors';
import { useEffect } from 'react';

export const useGetNameRole = (valueRole) => {
	const d = useDispatch();
	const roles = useSelector(getRolesSD);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => {
		if (roles.length === 0) d(getRolesAction());
	}, []);

	return roles?.find((role) => role.value === valueRole?.item_name)?.label;
};
